import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import Modal from 'components/Modal';
import Button from 'components/Button';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import TripActions from 'store/ducks/trip';
import { format } from 'date-fns';
import { WrapperButtons, WrapperTable } from './styles';

const ModalContainer = styled.div`
  padding: 20px;
  min-width: 600px;
  max-width: 800px;
`;

function ModalSelecionarViagem({ open, onClose, onSelect }) {
  const dispatch = useDispatch();
  const { viagens } = useSelector((state) => state.trip);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (open) {
      dispatch(TripActions.getViagensRequest());
    }
  }, [open, dispatch]);

  // Filtrar apenas viagens sem carga (sem carga_id) e aplicar busca
  const filteredViagens = viagens.filter((viagem) => {
    // Excluir viagens que já estão vinculadas a uma carga
    if (viagem.carga_id) {
      return false;
    }
    // Aplicar filtro de busca
    return (
      String(viagem.id || '').toUpperCase().includes(search.toUpperCase()) ||
      String(viagem.referencia || '').toUpperCase().includes(search.toUpperCase())
    );
  });

  const tableData = filteredViagens.map((viagem) => ({
    id: viagem.id,
    referencia: viagem.referencia || '-',
    data_emissao: viagem.data_emissao ? format(new Date(viagem.data_emissao), 'dd/MM/yyyy') : '-',
    valor: viagem.transporte?.valor_servico || viagem.transporte?.valor_carga || 0,
    invoices_count: viagem.invoices?.length || 0,
  }));

  const handleSelect = (viagemId) => {
    const viagem = viagens.find((v) => v.id === viagemId);
    if (viagem && onSelect) {
      onSelect(viagem);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Selecionar Viagem">
      <ModalContainer>
        <div style={{ marginBottom: '20px' }}>
          <SearchInput
            onChange={(e) => setSearch(e.target.value)}
            onClear={() => setSearch('')}
            value={search}
            placeholder="Buscar por ID ou referência..."
          />
        </div>

        <WrapperTable>
          <Table
            columns={[
              { label: 'ID', id: 'id' },
              { label: 'Referência', id: 'referencia' },
              { label: 'Data de Emissão', id: 'data_emissao' },
              { label: 'Valor', id: 'valor' },
              { label: 'Nº de Notas', id: 'invoices_count' },
              { label: 'Ações', id: 'actions' },
            ]}
            data={tableData}
            customComponent={{
              valor: (e) =>
                e.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }),
              actions: (e, item) => (
                <Button
                  label="Selecionar"
                  onClick={() => handleSelect(item.id)}
                  color="primary"
                  width="100px"
                  height="30px"
                />
              ),
            }}
          />
        </WrapperTable>

        <WrapperButtons>
          <Button
            label="Cancelar"
            onClick={onClose}
            color="secondary"
          />
        </WrapperButtons>
      </ModalContainer>
    </Modal>
  );
}

export default ModalSelecionarViagem;

